import React from 'react';
import { motion } from 'framer-motion';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../../redux/store';
import { setFinishUrl } from '../../../redux/slices/customizationSlice';
import type { FinishSwatchKey } from '../customizerConfig';
import SwatchCard from '../shared/SwatchCard';
import { THEME } from '../theme';

interface FinishSectionProps {
  /** Which swatch key to read finishes from (defaults to 'woodFinishes') */
  finishSwatchKey?: FinishSwatchKey;
}

const FinishSection: React.FC<FinishSectionProps> = ({ finishSwatchKey = 'woodFinishes' }) => {
  const dispatch = useDispatch();
  const finishes = useSelector((s: RootState) => s.customization.swatches[finishSwatchKey] ?? []);
  const selected = useSelector((s: RootState) => s.customization.finishUrl);

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.25 }}>
      <div className="flex items-center justify-between mb-4">
        <span className="text-[10px] font-bold uppercase tracking-[0.15em]" style={{ color: THEME.primaryLight }}>Wood Finish</span>
        {selected && <span className="text-[10px] font-semibold" style={{ color: THEME.primaryLight }}>1 Selected</span>}
      </div>
      <div className="flex flex-wrap gap-3">
        {finishes.length === 0 && (
          <div className="flex gap-3">
            {[1, 2, 3].map((i) => <div key={i} className="w-[88px] h-[88px] rounded-2xl bg-white/5 animate-pulse" />)}
          </div>
        )}
        {finishes.map((url: string, i: number) => (
          <SwatchCard
            key={i}
            url={url}
            label={`Finish ${i + 1}`}
            selected={selected === url}
            onClick={() => dispatch(setFinishUrl(selected === url ? null : url))}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default FinishSection;
